import { render, staticRenderFns } from "./inventory-order.vue?vue&type=template&id=2eba1d92"
import script from "./inventory-order.vue?vue&type=script&lang=js"
export * from "./inventory-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports